module.exports = __webpack_public_path__ + "img/landrover.3e97d6e1.png";